import { FC } from "react";
import { twMerge } from "tailwind-merge";

const SectionLabel: FC<{
  className?: string;
}> = ({ children, className }) => {
  return (
    <p
      className={twMerge(
        "font-helvetica text-sm font-bold text-[#6F5F7B] desktop:text-lg",
        className
      )}
    >
      {children}
    </p>
  );
};

export default SectionLabel;
